import { render, staticRenderFns } from "./QueryPriceResult.vue?vue&type=template&id=f6cc238c&scoped=true&"
import script from "./QueryPriceResult.vue?vue&type=script&lang=js&"
export * from "./QueryPriceResult.vue?vue&type=script&lang=js&"
import style0 from "./QueryPriceResult.vue?vue&type=style&index=0&id=f6cc238c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6cc238c",
  null
  
)

export default component.exports